import { render, staticRenderFns } from "./Step20.vue?vue&type=template&id=4c9ed223&scoped=true"
import script from "./Step20.vue?vue&type=script&lang=js"
export * from "./Step20.vue?vue&type=script&lang=js"
import style0 from "./Step20.vue?vue&type=style&index=0&id=4c9ed223&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9ed223",
  null
  
)

export default component.exports